export default __webpack_public_path__ + "static/media/expired-bg-md.ba7daa4f.png";